import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=1ccf056c&scoped=true&"
var script = {}
import style0 from "./chat.vue?vue&type=style&index=0&id=1ccf056c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccf056c",
  null
  
)

export default component.exports